import { BaseReq } from "@/core/interface";
import { HttpService } from "@/core/services/http.service";

export class TableListService {
  static useChangeColumnsApi() {
    const api = (data: ColumnReq) =>
      HttpService.axios({
        method: "POST",
        url: "/title/add",
        data,
      });
    return HttpService.useRequest<void>(api);
  }
  static useGetColumnsApi() {
    const api = (data: ColumnReq) =>
      HttpService.axios({
        method: "POST",
        url: `/title/getTitle`,
        data,
      });
    return HttpService.useRequest<ColumnReq>(api);
  }

  static useGetColumnsSettingApi() {
    const api = (bizType: string) =>
      HttpService.axios({
        method: "GET",
        url: `/list_config/query/${bizType}`,
      });
    return HttpService.useRequest<ListConfig>(api);
  }
  static useSetColumnsSettingApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: `/list_config/save`,
        data
      });
    return HttpService.useRequest<ListConfig>(api);
  }
}

interface ColumnReq {
  bizType: string;
  tenantUserId?: 0;
  titleParamReqs?: Array<TitleParamReq>;
}

export interface TitleParamReq {
  attributeValue: string;
  name: string;
  titleOrder?: 0;
}

export class ListConfig extends BaseReq {
  bizName: string = "";
  bizType: string = "";
  id: string = "";
  content: string = "";
  customData:any;
}
